export const STATUS_FILTER_OPTIONS = [
  { value: "Draft", label: "Draft" },
  { value: "Scheduled", label: "Scheduled" },
  { value: "Active", label: "Active" },
  { value: "Concluded", label: "Concluded" },
];

export const TIME_BOUND_FILTER_FIELDS = [
  { key: "startDate", label: "Start date", type: "date" },
  { key: "endDate", label: "End date", type: "date" },
  {
    key: "status",
    label: "Status",
    type: "select",
    emptyOptionLabel: "All statuses",
    options: STATUS_FILTER_OPTIONS,
  },
];
